import { render, staticRenderFns } from "./product-unit.vue?vue&type=template&id=eeb0f4ca&lang=pug&"
import script from "./product-unit.vue?vue&type=script&lang=js&"
export * from "./product-unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports